import { SxProps, Theme } from '@mui/material/styles';
import { colorPalette, fontFamily, fontSize, getSpacing } from 'stylesheet';

export const getSelectOrInputFieldSx = (width?: number): SxProps<Theme> => ({
  '& .MuiOutlinedInput-root': {
    fontFamily: fontFamily.main,
    fontSize: fontSize.p1,
    lineHeight: '1.5',
    backgroundColor: colorPalette.white,
    width: width ? `${width}px` : '100%',
    padding: 0,
    '& .MuiSelect-root': {
      padding: `${getSpacing(1)} ${getSpacing(4)} ${getSpacing(1)} ${getSpacing(2)}`,
      '&:focus': {
        backgroundColor: colorPalette.white,
      },
    },
    '&.Mui-focused fieldset': {
      border: `1px solid ${colorPalette.grey_600}`,
    },
  },
  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: colorPalette.status_error,
  },
  '& .MuiFormHelperText-contained': {
    margin: `${getSpacing(0.5)} 0`,
    fontFamily: fontFamily.main,
    fontSize: fontSize.p3,
    lineHeight: '1.5',
    color: colorPalette.status_error,
  },
  '& .MuiOutlinedInput-multiline': {
    padding: `${getSpacing(1)} ${getSpacing(4)} ${getSpacing(1)} ${getSpacing(2)}`,
  },
});
